"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _reportUtil = require("../../utils/reportUtil");
var _HTMLRenderer = _interopRequireDefault(require("../../common/components/HTMLRenderer"));
var _componentUtils = require("../../common/componentUtils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */

const Row = _tpmProductIntl.Grid.Row,
  Col = _tpmProductIntl.Grid.Col;
const formatAdvantageCommon = (properties, options = {}) => {
  const _ref = properties || {},
    _ref$porintId = _ref.porintId,
    porintId = _ref$porintId === void 0 ? '' : _ref$porintId,
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? 'default' : _ref$bg,
    _ref$titleList = _ref.titleList,
    titleList = _ref$titleList === void 0 ? [] : _ref$titleList,
    _ref$desc = _ref.desc,
    desc = _ref$desc === void 0 ? '' : _ref$desc,
    _ref$list = _ref.list,
    list = _ref$list === void 0 ? [] : _ref$list,
    _ref$footerTitle = _ref.footerTitle,
    footerTitle = _ref$footerTitle === void 0 ? '' : _ref$footerTitle,
    _ref$footerTitleHref = _ref.footerTitleHref,
    footerTitleHref = _ref$footerTitleHref === void 0 ? '' : _ref$footerTitleHref;
  const handledTitleList = titleList === null || titleList === void 0 ? void 0 : titleList.map((activityItem, index) => {
    const _ref2 = activityItem || {},
      _ref2$img = _ref2.img,
      img = _ref2$img === void 0 ? '' : _ref2$img,
      _ref2$text = _ref2.text,
      text = _ref2$text === void 0 ? '' : _ref2$text;
    return {
      img: (0, _componentUtils.doComponentsUploadEvent)(img).url,
      text: text ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
        html: text
      }) : ''
    };
  });
  const handledLogoList = list === null || list === void 0 ? void 0 : list.map((activityItem, index) => {
    const _ref3 = activityItem || {},
      _ref3$btnText = _ref3.btnText,
      btnText = _ref3$btnText === void 0 ? '' : _ref3$btnText,
      _ref3$btnHref = _ref3.btnHref,
      btnHref = _ref3$btnHref === void 0 ? '' : _ref3$btnHref,
      _ref3$title = _ref3.title,
      title = _ref3$title === void 0 ? '' : _ref3$title,
      _ref3$desc = _ref3.desc,
      desc = _ref3$desc === void 0 ? '' : _ref3$desc;
    const btnExtendProps = {
      'report-event': 'click_Doc_item_btn',
      'report-ext1': index,
      'report-ext2': btnText || '',
      'report-ext3': btnHref || '',
      'target': '_blank'
    };
    return {
      title,
      desc,
      btn: btnText ? /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
        align: "center",
        icon: true,
        href: btnHref
      }, btnExtendProps), btnText) : null
    };
  });
  return {
    porintId,
    title: handledTitleList,
    desc,
    bg,
    list: handledLogoList,
    footerTitle,
    footerTitleHref
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatAdvantageCommo = formatAdvantageCommon(data, {
        domains
      }),
      porintId = _formatAdvantageCommo.porintId,
      title = _formatAdvantageCommo.title,
      desc = _formatAdvantageCommo.desc,
      bg = _formatAdvantageCommo.bg,
      list = _formatAdvantageCommo.list,
      footerTitle = _formatAdvantageCommo.footerTitle,
      footerTitleHref = _formatAdvantageCommo.footerTitleHref;
    console.log('doc--', formatAdvantageCommon(data, {
      domains
    }));
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId,
      className: "gems-materials-qci__newUI-doc"
    }, (0, _reportUtil.reportShow)(['show_newUI_Doc', componentKey, ''])), /*#__PURE__*/React.createElement(_tpmProductIntl.Section, {
      bg: bg,
      title: title,
      desc: desc,
      footLinks: footerTitle && footerTitleHref ? [{
        children: footerTitle,
        icon: true,
        href: footerTitleHref
      }] : []
    }, /*#__PURE__*/React.createElement(Row, {
      gap: 20,
      gutter: 5
    }, list.map((item, index) => /*#__PURE__*/React.createElement(Col, {
      span: 8,
      pad: 24,
      phone: 24,
      key: index
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.Doc, item))))));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}